import React, { useState, useMemo } from 'react';
import styles from './Subscription.module.scss';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { Input } from '@/components/Input';
import { Button, buttonVariants } from '@/components/Button';
const getUnitAmount = (plan, billingCycle, currencyCode) => {
  if (!plan?.pricing) return null;
  const pricing = plan.pricing[currencyCode] || plan.pricing.USD || {};
  switch (billingCycle) {
    case 'quarterly':
      return pricing.quarterly;
    case 'yearly':
      return pricing.yearly;
    default:
      return pricing.monthly;
  }
};

export const ModifySeatsModal = ({
  onClose,
  subscriptionData,
  plan,
  billingCycle,
  currency,
  onConfirm,
}) => {
  const [totalSeats, setTotalSeats] = useState('');
  const [error, setError] = useState(null);
  const seats = useMemo(() => {
    const q = subscriptionData?.occupiedSeats;
    if (q == null || q === '') return 2;
    const n = Number(q);
    return Number.isFinite(n) && n > 0 ? n : 2;
  }, [subscriptionData]);
  const amount = getUnitAmount(plan, billingCycle, currency);
  const unitNum = amount != null ? Number(amount) : NaN;
  const totalAmount =
    Number.isFinite(unitNum) && seats > 0
      ? unitNum * (Number(totalSeats) || seats)
      : null;

  const currencySymbol = currency === 'INR' ? '₹' : '$';
  const onConfirmClick = () => {
    if (!totalSeats) {
      setError('Total seats is required');
      return;
    }

    if (totalSeats <= seats) {
      setError('Total seats must be greater than current seats');
      return;
    } else {
      setError(null);
      onConfirm(Number(totalSeats));
    }
  };
  return (
    <div className={styles.modifySeatsModal}>
      <Text
        variant={textVariantsEnum.Text_xl}
        fontWeight={fontWeightEnum.Medium}
      >
        Modify Seats
      </Text>
      <Text
        variant={textVariantsEnum.Text_md}
        fontWeight={fontWeightEnum.Normal}
      >
        Current Seats : {seats}
      </Text>
      <Text
        variant={textVariantsEnum.Text_sm}
        fontWeight={fontWeightEnum.Medium}
      >
        Modify Seats will cancel your current subscription and create a new
        subscription with the new seats. The amount will be refunded based on
        the number of days left in the current subscription cycle.
      </Text>
      <Input
        type="number"
        label="New Seats"
        value={totalSeats}
        onChange={(e) => {
          setTotalSeats(e.target.value);
          setError(null);
        }}
        errorMessage={error}
      />
      <Text
        variant={textVariantsEnum.Text_lg}
        fontWeight={fontWeightEnum.Medium}
      >
        {totalAmount != null ? (
          <>
            Total : {currencySymbol}
            {totalAmount.toFixed(2)}{' '}
            <span className={styles.checkoutSeatsPlanModalBreakdown}>
              ({currencySymbol}
              {Number.isFinite(unitNum) ? unitNum.toFixed(2) : '—'} ×{' '}
              {Number(totalSeats) || seats} seat{seats !== 1 ? 's' : ''})
            </span>
          </>
        ) : (
          'Price unavailable for this selection.'
        )}
      </Text>
      <div className={styles.buttonsContainer}>
        <Button
          variant={buttonVariants.secondary}
          text="Cancel"
          onClick={onClose}
        />
        <Button
          variant={buttonVariants.primary}
          text="Proceed to pay"
          onClick={onConfirmClick}
        />
      </div>
    </div>
  );
};
